import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const IconHome = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IconCalendar = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconClipboard = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="12" y2="16"/></svg>;
const IconUser = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconUsers = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>;
const IconLogout = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;
const IconSettings = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>;
const IconMore = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="5" r="1" fill="currentColor"/><circle cx="12" cy="12" r="1" fill="currentColor"/><circle cx="12" cy="19" r="1" fill="currentColor"/></svg>;

export default function Sidebar({ page, setPage }) {
    const { currentUser, userProfile, logout } = useAuth();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const isAdmin = userProfile?.role === 'admin';

    const initials = userProfile?.voornaam
        ? `${userProfile.voornaam[0]}${userProfile.achternaam?.[0] || ''}`.toUpperCase()
        : currentUser?.email?.[0]?.toUpperCase() || '?';

    const displayName = userProfile?.voornaam
        ? `${userProfile.voornaam} ${userProfile.achternaam || ''}`
        : currentUser?.email || '';

    function navigate(id) {
        setPage(id);
        setDrawerOpen(false);
    }

    // Bottom nav main items (max 4 + more)
    const mainNavItems = [
        { id: 'dashboard', label: 'Home', Icon: IconHome },
        { id: 'beschikbaarheid', label: 'Beschikbaar', Icon: IconCalendar },
        { id: 'planning', label: 'Planning', Icon: IconClipboard },
        { id: 'profiel', label: 'Profiel', Icon: IconUser },
    ];

    const adminNavItems = [
        { id: 'admin-vrijwilligers', label: 'Vrijwilligers', Icon: IconUsers },
        { id: 'admin-planning', label: 'Planning', Icon: IconClipboard },
        { id: 'admin-weken', label: 'Weken', Icon: IconSettings },
    ];

    const navItem = (id, label, Icon) => (
        <button key={id} className={`nav-item ${page === id ? 'active' : ''}`} onClick={() => navigate(id)}>
            <Icon /> {label}
        </button>
    );

    return (
        <>
            {/* ── DESKTOP SIDEBAR ── */}
            <div className="sidebar">
                <div className="sidebar-logo">
                    <div className="sidebar-logo-text">🏕 Kamp</div>
                    <div className="sidebar-logo-sub">Vrijwilligersbeheer</div>
                </div>
                <div className="sidebar-nav">
                    <div className="nav-section-label">Mijn overzicht</div>
                    {navItem('dashboard', 'Dashboard', IconHome)}
                    {navItem('beschikbaarheid', 'Beschikbaarheid', IconCalendar)}
                    {navItem('planning', 'Mijn planning', IconClipboard)}
                    {navItem('profiel', 'Mijn profiel', IconUser)}
                    {isAdmin && <>
                        <div className="nav-section-label" style={{ marginTop: 8 }}>Beheer</div>
                        {navItem('admin-vrijwilligers', 'Vrijwilligers', IconUsers)}
                        {navItem('admin-planning', 'Planning beheer', IconClipboard)}
                        {navItem('admin-weken', 'Weken beheer', IconSettings)}
                    </>}
                </div>
                <div className="sidebar-footer">
                    <div className="sidebar-user">
                        <div className="sidebar-avatar">{initials}</div>
                        <div className="sidebar-user-info">
                            <div className="sidebar-user-name">{displayName}</div>
                            <div className="sidebar-user-role">{isAdmin ? '⚙ Admin' : '👤 Vrijwilliger'}</div>
                        </div>
                    </div>
                    <button className="nav-item" onClick={logout} style={{ marginTop: 4 }}>
                        <IconLogout /> Uitloggen
                    </button>
                </div>
            </div>

            {/* ── MOBILE TOP BAR ── */}
            <div className="mobile-topbar">
                <div className="mobile-topbar-logo">🏕 Kamp</div>
                <div className="mobile-topbar-user">
                    <div className="mobile-topbar-avatar">{initials}</div>
                </div>
            </div>

            {/* ── MOBILE BOTTOM NAV ── */}
            <div className="mobile-bottom-nav">
                <div className="mobile-bottom-nav-inner">
                    {mainNavItems.map(({ id, label, Icon }) => (
                        <button key={id} className={`mobile-nav-item ${page === id ? 'active' : ''}`} onClick={() => navigate(id)}>
                            <Icon />
                            <span>{label}</span>
                        </button>
                    ))}
                    {/* More button — opens drawer */}
                    <button className={`mobile-nav-item ${adminNavItems.some(i => i.id === page) ? 'active' : ''}`}
                            onClick={() => setDrawerOpen(true)}>
                        <IconMore />
                        <span>Meer</span>
                    </button>
                </div>
            </div>

            {/* ── MOBILE DRAWER ── */}
            <div className={`mobile-drawer-overlay ${drawerOpen ? 'open' : ''}`} onClick={() => setDrawerOpen(false)} />
            <div className={`mobile-drawer ${drawerOpen ? 'open' : ''}`}>
                <div className="mobile-drawer-handle" />

                {/* User info */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '4px 24px 16px' }}>
                    <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'var(--primary-pale)', color: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: 15 }}>{initials}</div>
                    <div>
                        <div style={{ fontWeight: 600, fontSize: 15 }}>{displayName}</div>
                        <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{isAdmin ? '⚙ Admin' : '👤 Vrijwilliger'}</div>
                    </div>
                </div>

                <div className="mobile-drawer-divider" />

                {isAdmin && <>
                    <div className="mobile-drawer-section">Beheer</div>
                    {adminNavItems.map(({ id, label, Icon }) => (
                        <button key={id} className={`mobile-drawer-item ${page === id ? 'active' : ''}`} onClick={() => navigate(id)}>
                            <Icon />{label}
                        </button>
                    ))}
                    <div className="mobile-drawer-divider" />
                </>}

                <button className="mobile-drawer-logout" onClick={() => { setDrawerOpen(false); logout(); }}>
                    <IconLogout /> Uitloggen
                </button>
            </div>
        </>
    );
}